import Vue from "vue"
import io from "socket.io-client";

import { getUUID } from '@/utils/utils.js'
import { _ } from "core-js";
import FingerprintJS from '@fingerprintjs/fingerprintjs';
export const WSocketEvent = {
  /** 连接成功 */
  CONNECTED: 'connected',
  /** 消息 */
  MESSAGE: 'message',
  /** 错误 */
  ERROR: 'error',
  /** 关闭 */
  CLOSE: 'close'
}
export const WSocketMessageType = {
  /** 发言 */
  speak: 'speak',
  /** 进场提醒 */
  in: 'in',
  /** 置顶消息 */
  top: 'top',
  /** 送礼消息 */
  present: 'present',
  /** 直播间分享 */
  share: 'share',
  /** 主播公告 */
  notice: 'notice',
  /** 点赞 */
  likeNumUpdate: 'likeNumUpdate',
  /** 抽奖 */
  lottery: 'lottery',
  /** 观看人数 */
  watchNumUpdate:'watchNumUpdate',
  /** 取消禁言 */
  unShutUp:'unShutUp',
  /** 禁言 */
  shutUp:'shutUp',
  /** 直播开始 */ 
  startLive:'startLive',
  /** 直播结束 */ 
  stopLive:'stopLive',
  /** 发言拒审 */ 
  refusal:'refusal',
   /** 抽奖信息更新 */ 
  lotteryUpdated:'lotteryUpdated',
   /** 抽奖结果 */ 
  lotteryOpened:'lotteryOpened',

}

export const socketio =  {
  async socketInit(){
    var chatVue = window.chatVue
    var indexVue = window.indexVue
    if(!indexVue.visitorId){
      const fp = await FingerprintJS.load()
      const result = await fp.get()
      indexVue.visitorId = result.visitorId
    }
    const wsUrl = process.env.VUE_APP_CHAT_WEBSOCKET_URL
    const wsUrlArr = wsUrl.split('/')
    const wsDomain = wsUrlArr[0] + '//' + wsUrlArr[2]
    
    Vue.prototype.socketIo = io(wsDomain, {
      path: '/'+wsUrlArr.slice(3).join('/'),
      transports: ["websocket"],
      query: {
        uuid: indexVue.uuid,
        live_id: indexVue.id,
        invite_user:indexVue.inviteId || '',
        access_token: localStorage.getItem('live_access_token') || '',
        vistor_id:indexVue.visitorId
      },
    })

    Vue.prototype.socketIo.on("connect", () => {
      console.log('socket连接成功')
      indexVue.getShareInfo();
    })
    Vue.prototype.socketIo.on('join',(data)=>{
      chatVue.entryFormHandle({content:`欢迎<span style="color: #1e54d5">${data.user.nick_name}</span>进场`})
    })
    Vue.prototype.socketIo.on('login',(data)=>{
      indexVue.userId = data.user.user_id
      indexVue.userinfo = data.user
      indexVue.share_url = data.share_url
      // 邀请进入授权成功后打标，避免同会话重复清 token
      if (typeof indexVue.markInviteOauthDone === 'function') {
        indexVue.markInviteOauthDone()
      }
      // indexVue.pc_url = data.pc_url
      indexVue.isMute = indexVue.userinfo.shutup == 1 && indexVue.liveinfo.shutup_status != 2 && indexVue.liveinfo.live_status != 3 ? false : true
      if (indexVue.userinfo.has_input_pass == 1 && indexVue.liveinfo.encryption_status == 2) {
        indexVue.inviteCodeShow = true
      }
      // // 判断是否强制实名
      if (indexVue.liveinfo.is_real && indexVue.liveinfo.encryption_status == 2 && indexVue.userinfo.has_input_pass == 2) {//强制实名，显示实名弹框，前提是直播加密开启并且填写了
        indexVue.openSign(1)
      }
      if(indexVue.liveinfo.is_real && indexVue.liveinfo.encryption_status != 2){
        indexVue.openSign(1)
      }
      
      // 判断强制实名和直播加密的需要加水印     
      // if(indexVue.liveinfo.encryption_status == 2 && indexVue.liveinfo.is_real){
      //   indexVue.iswater = true
      // }

      indexVue.getShareInfo();

    })

    // Vue.prototype.socketIo.on("token", (data) => {//登录成功
    //   indexVue.$message({
    //     message: '授权登录成功',
    //     type: 'success',
    //     duration: 1500
    //   })
    //   localStorage.setItem('live_access_token',data.live_access_token)
    //   localStorage.setItem('uuid',indexVue.uuid)
    //   indexVue.loginShow = false
    //   indexVue.getUserInfo()
    // })
    Vue.prototype.socketIo.on("token_expired", (data) => {//登录失效
      console.log('socket登录失效')
      localStorage.removeItem('live_access_token')
      indexVue.wxLogin(1)
    })

    Vue.prototype.socketIo.on("history", (data) => {
      chatVue.getmessage(data,'history')
    })
    Vue.prototype.socketIo.on("message", (data) => {
      chatVue.getmessage(data)
    })
    Vue.prototype.socketIo.on("control", (data) => {
      chatVue.receiveHandle(data)
    })

    Vue.prototype.socketIo.on("error", (data) => {
      // indexVue.$toast(data.message);
      console.log(data.message)
    })
    Vue.prototype.socketIo.on('disconnect', () => {
      // chatVue.$notify({ type: 'warning', message: '聊天服务器已断开, 5秒后重连' })
      console.log('聊天服务器已断开')
      
    })


  },
  socketsend(type,params){
    Vue.prototype.socketIo.emit(type,params)
  }
                                 
}



